import { render, staticRenderFns } from "./OrderDetailHeader.vue?vue&type=template&id=efb49594&scoped=true"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=js"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailHeader.vue?vue&type=style&index=0&id=efb49594&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb49594",
  null
  
)

export default component.exports